import { loadAgent } from './dist/pendo.module.min.js';
import { startAgent, getServerConfig } from './setup.js';

export async function initialize(options = {}) {
    return startAgent(loadAgent, options);
}

export { GuideMarkdown, Replay, TextCapture, Feedback, VocPortal } from './dist/pendo.module.min.js';
export { getServerConfig };

